// Time formatting utilities

/**
 * Format time in seconds to MM:SS format
 * @param sec - Time in seconds
 * @returns Formatted time string (e.g., "1:28")
 */
export function formatTime(sec: number): string {
  if (!isFinite(sec)) return '0:00';
  const m = Math.floor(sec / 60);
  const s = Math.floor(sec % 60);
  return `${m}:${s.toString().padStart(2, '0')}`;
}

/**
 * Format time in milliseconds to MM:SS format
 * @param ms - Time in milliseconds
 * @returns Formatted time string (e.g., "1:28")
 */
export function formatTimeMs(ms: number): string {
  return formatTime(ms / 1000);
}

